import React from 'react';
import { Avatar, useMediaQuery } from '@material-ui/core';
import { Skeleton, AvatarGroup } from '@material-ui/lab';
import styled from 'styled-components';
import { defaultMuiTheme } from '../../styles/MaterialTheme';
import { makeRange } from '../../utils';
import { CollectionAboutContainer, CollectionBottomContainer, CollectionDescriptionContainer, CollectionTabContainer, CollectionTopContainer } from '../Collections';
import { CATALOG_IMAGE_SIZE, SMALL_CATALOG_IMAGE_SIZE } from '../Image';
import { FeaturedImageContainer } from '../Image/components/CollectionFeaturedImage';
const BREAKPOINT_500PX = 500;
const CatalogImageSkeleton = styled(Skeleton) `
    width: ${CATALOG_IMAGE_SIZE};
    height: ${CATALOG_IMAGE_SIZE};
    margin-bottom: 2rem;

    ${defaultMuiTheme.breakpoints.down('xs')} {
        width: ${SMALL_CATALOG_IMAGE_SIZE};
        height: ${SMALL_CATALOG_IMAGE_SIZE};
    }
`;
const Wrapper = styled.div `
    display: flex;
    flex-direction: column;
`;
const CollaboratorsWrapper = styled.div `
    display: flex;
    margin-top: 2rem;
    align-items: center;

    > span {
        margin-left: 0.5rem;
    }
`;
const StatsWrapper = styled.div `
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 2rem;
`;
const Stat = styled.div `
    display: flex;
    flex-direction: column;

    ${defaultMuiTheme.breakpoints.down(BREAKPOINT_500PX)} {
        flex: 0 45%;
    }
`;
const StyledAvatar = styled(Avatar) `
    background-color: transparent !important;
    border: none !important;
`;
const SectionHeaderSkeleton = styled(Skeleton) `
    margin: 1rem 0;
`;
const ActionButtonsSkeleton = styled(Skeleton) `
    margin-top: 2rem;
`;
const CardWrapper = styled.div `
    height: 600px;
    border: 1px solid ${(props) => props.theme.colors.border};
    border-radius: 4px;
    overflow: auto;
`;
const CardSkeleton = styled(Skeleton) `
    margin: 1rem;
`;
export const CollectionLoader = ({ hideCollaborators = false, hideOwnerChip = false }) => {
    const isUnder500 = useMediaQuery(defaultMuiTheme.breakpoints.down(BREAKPOINT_500PX));
    const hideDescription = useMediaQuery(defaultMuiTheme.breakpoints.down('md'));
    return (React.createElement(Wrapper, null,
        React.createElement(CollectionTopContainer, null,
            React.createElement(CollectionAboutContainer, null,
                React.createElement(CatalogImageSkeleton, { variant: "circle", width: CATALOG_IMAGE_SIZE, height: CATALOG_IMAGE_SIZE }),
                hideOwnerChip ? null : React.createElement(Skeleton, { variant: "text", width: "20%" }),
                React.createElement(Skeleton, { variant: "rect", width: "80%", height: 50 }),
                React.createElement(Skeleton, { variant: "text", width: "30%" }),
                hideCollaborators ? null : (React.createElement(CollaboratorsWrapper, null,
                    React.createElement(AvatarGroup, null, makeRange(1, isUnder500 ? 1 : 4).map((index) => (React.createElement(StyledAvatar, { key: index },
                        React.createElement(Skeleton, { variant: "circle", width: 40, height: 40 }))))),
                    React.createElement(Skeleton, { variant: "rect", width: 200, height: 40 }))),
                React.createElement(ActionButtonsSkeleton, { variant: "rect", width: 200, height: 50 }),
                React.createElement(StatsWrapper, null, makeRange(1, 4).map((index) => (React.createElement(Stat, { key: index },
                    isUnder500 ? null : React.createElement(Skeleton, { variant: "rect", width: 50, height: 50 }),
                    React.createElement(Skeleton, { variant: "text", width: "100%" })))))),
            React.createElement(FeaturedImageContainer, null,
                React.createElement(Skeleton, { variant: "rect", width: "100%", height: "100%" }))),
        React.createElement(CollectionBottomContainer, null,
            hideDescription ? null : (React.createElement(CollectionDescriptionContainer, null,
                React.createElement(SectionHeaderSkeleton, { variant: "rect", width: "30%", height: 40 }),
                React.createElement(Skeleton, { variant: "rect", height: 600 }))),
            React.createElement(CollectionTabContainer, null,
                React.createElement(SectionHeaderSkeleton, { variant: "rect", width: "50%", height: 40 }),
                React.createElement(CardWrapper, null, makeRange(1, 6).map((index) => (React.createElement(CardSkeleton, { key: index, variant: "rect", height: 125 }))))))));
};
//# sourceMappingURL=CollectionLoader.js.map